import React from "react";
import { UserPlus, ClipboardList, TrendingUp } from "lucide-react";

const STEPS = [
  {
    num: "01",
    icon: UserPlus,
    title: "Create your account",
    desc: "Sign up in 30 seconds. Set up your coach profile and you're ready to onboard your first client.",
  },
  {
    num: "02",
    icon: ClipboardList,
    title: "Add clients & assign plans",
    desc: "Invite clients via email or WhatsApp. Assign personalized workout & diet plans in a few taps.",
  },
  {
    num: "03",
    icon: TrendingUp,
    title: "Track, coach & grow",
    desc: "Monitor progress, send reminders, and celebrate every client win — all from one dashboard.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 md:py-28" data-testid="how-it-works-section">
      <div className="section-container">
        <div className="text-center max-w-2xl mx-auto mb-14 reveal">
          <div className="chip mb-4">How it works</div>
          <h2 className="font-display text-4xl md:text-5xl leading-tight">
            Go live in <span className="gradient-text">under 5 minutes</span>
          </h2>
          <p className="mt-4 text-white/60">Three simple steps to your first tracked workout.</p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute top-20 left-[16%] right-[16%] h-px bg-gradient-to-r from-cyan-400/0 via-cyan-400/40 to-cyan-400/0" aria-hidden="true" />
          <div className="grid md:grid-cols-3 gap-6 md:gap-10">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <div key={i} className="reveal text-center md:text-left" data-testid={`step-${i}`}>
                  <div className="relative mx-auto md:mx-0 w-14 h-14 rounded-2xl flex items-center justify-center mb-5 pulse-glow"
                       style={{ background: "linear-gradient(135deg, rgba(34,211,238,0.15), rgba(59,130,246,0.1))", border: "1px solid rgba(34,211,238,0.3)" }}>
                    <Icon size={22} className="text-cyan-300" />
                    <span className="absolute -top-2 -right-2 text-[10px] font-bold text-[#050814] bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full w-6 h-6 flex items-center justify-center">{s.num}</span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">{s.title}</h3>
                  <p className="text-sm text-white/60 leading-relaxed">{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
